import { Grid, Paper, Button, MenuItem } from "@material-ui/core"
import { useEffect } from "react";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import { useDispatch, useSelector } from "react-redux"
import { fetchBancos, fetchCategoriasEfectores, fetchCondicionIva } from "../../../../actions/contrataciones/contratacionesDatosContables";
import { useForm } from "../../../../hooks/useForm";
import {guardarInformacionContableProveedor, traerDatosContablesProveedor} from "../../../../actions/compras/ProveedoresAction";
import { MENU_PROVEEDORES } from "../../../../utils/constants";
import { Save } from "@material-ui/icons";


export const DatosContablesProveedor = (props) => {
    const {esNuevo} = props;
    const {Menu} = props;
    const dispatch = useDispatch();
    const {bancos,categorias,condicionIva} = useSelector((state) => state.contratacionesDatosBancarios)
    const {proveedorInfo, datosContables} = useSelector((state) => state.proveedores)

    useEffect(() => {
        if(proveedorInfo.idProveedor)
        {
          dispatch(traerDatosContablesProveedor(proveedorInfo.idProveedor))
        }
      }, [])

    useEffect(() => {
        dispatch(fetchBancos())
        dispatch(fetchCategoriasEfectores())
        dispatch(fetchCondicionIva())
    }, [])

    console.log(datosContables)

    let datosNuevos = {
        idBanco: null,
        idTipoCuenta: null,
        cbu: "",
        alias: "",
        plazoPago: null,
        plazoDebito: null,
        plazoRecepcionFacturas: null,
        idFormaPago: null,
        idCondicionIva: null,
        idCategoriaAdministrativa: null
}

    const [
        formValues,
        handleInputChange,
    ] = useForm(esNuevo ? datosNuevos : datosContables);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(guardarInformacionContableProveedor(formValues))
    }
    return(
        <>
            <ValidatorForm onSubmit={handleSubmit}>
                <Grid container spacing={1} component={Paper} style={{padding: "40px"}}>
                    <Grid item sm={3}>
                        <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Banco"
                            name="idBanco"
                            value={datosContables.idBanco || ""}
                            onChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA} //deshabilito si es visualiación
                        >
                            {
                                bancos.map((banco) => (
                                    <MenuItem
                                        key={banco.idNominaBancos}
                                        value={banco.idNominaBancos}
                                    >
                                        {banco.nombre}
                                    </MenuItem>
                                ))
                            }

                        </SelectValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Tipo Cuenta"
                            name="idTipoCuenta"
                            value={datosContables.idTipoCuenta || ""}
                            onChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >
                            <MenuItem value={1}>Cuenta Corriente</MenuItem>
                            <MenuItem value={2}>Caja de Ahorro</MenuItem>
                        </SelectValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator
                            margin="normal"
                            fullWidth={true}
                            label="CBU"
                            name="cbu"
                            value={datosContables.cbu || ""}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >

                        </TextValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator
                            margin="normal"
                            fullWidth={true}
                            label="Alias"
                            name="alias"
                            value={datosContables.alias || ""}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >

                        </TextValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator
                            margin="normal"
                            fullWidth={true}
                            label="Plazo Pago"
                            name="plazoPago"
                            value={datosContables.plazoPago || ""}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >

                        </TextValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator
                            margin="normal"
                            fullWidth={true}
                            label="Plazo Debito"
                            name="plazoDebito"
                            value={datosContables.plazoDebito || ""}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >

                        </TextValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator
                            margin="normal"
                            fullWidth={true}
                            label="Plazo recepción facturas"
                            name="plazoRecepcionFacturas"
                            value={datosContables.plazoRecepcionFacturas || ""}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >

                        </TextValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Forma Pago"
                            name="idFormaPago"
                            value={datosContables.idFormaPago || ""}
                            onChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >
                            <MenuItem value={1}>Efectivo</MenuItem>
                            <MenuItem value={2}>Cheque</MenuItem>
                            <MenuItem value={3}>Transferencia</MenuItem>
                        </SelectValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Condición IVA"
                            name="idCondicionIva"
                            value={datosContables.idCondicionIva || ""}
                            onChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >
                            {
                                condicionIva.map((condicion) => (
                                    <MenuItem
                                        key={condicion.id}
                                        value={condicion.id}
                                    >
                                        {condicion.descripcion}
                                    </MenuItem>
                                ))
                            }

                        </SelectValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Categoria Administrativa"
                            name="idCategoriaAdministrativa"
                            value={datosContables.idCategoriaAdministrativa || ""}
                            onChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >
                            {
                                categorias.map((cat) => (
                                    <MenuItem
                                        key={cat.idCategoriaEfector}
                                        value={cat.idCategoriaEfector}
                                    >
                                        {cat.descripcion}
                                    </MenuItem>
                                ))
                            }

                        </SelectValidator>
                    </Grid>
                </Grid>
                {
                    Menu === MENU_PROVEEDORES.INGRESO && 
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            color="primary"
                            variant="contained"
                            startIcon={ <Save/> }
                            style={{ marginTop: "1rem" }}
                            type="submit"
                        >
                            Guardar Cambios
                        </Button>
                    </div>
                }
            </ValidatorForm>
        </>
    )
}